import { defineComponent as t, resolveComponent as r, openBlock as n, createBlock as p, normalizeProps as s, guardReactiveProps as c, withCtx as a, renderSlot as m, createElementVNode as d } from "vue";
import l from "../CdrIcon.vue.mjs";
import i from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const _ = t({
  name: "PlusSm",
  components: {
    CdrIcon: l
  },
  props: {
    props: {
      type: Object
    }
  }
}), f = /* @__PURE__ */ d("path", {
  role: "presentation",
  d: "M11 11H8a1 1 0 000 2h3v3a1 1 0 002 0v-3h3a1 1 0 000-2h-3V8a1 1 0 00-2 0v3z"
}, null, -1);
function u(o, h, v, $, C, P) {
  const e = r("cdr-icon");
  return n(), p(e, s(c(o.props)), {
    default: a(() => [m(o.$slots, "default"), f]),
    _: 3
  }, 16);
}
const z = /* @__PURE__ */ i(_, [["render", u]]);
export {
  z as default
};
